export default __webpack_public_path__ + "static/media/medical_device_image_3.e4a5dc84.jpg";